import { type ReactNode } from 'react';
import { Button, ContactCard, IconCheck } from '@aps/ui';
import { useNavigation } from '../app/navigation.js';
import { useSettings } from '../app/settings.js';
import { openTelegramLink } from '../lib/telegram.js';
import { useContact } from '../lib/use-contact.js';

/**
 * Buyurtma qabul qilingandan keyingi ekran.
 *
 * Bu "chiroyli tabrik" emas, KUTILMANI belgilaydigan ekran. MVP da
 * ilova ichida to'lov oqimi yo'q: karta raqami telefonda aytiladi va
 * chek botga tashlanadi (`docs/02-MAHSULOT.md`). Mijoz buni aynan
 * shu yerda bilib olishi kerak, aks holda u "to'lov tugmasi qani?"
 * deb qidiradi va operatorga qo'ng'iroq qiladi.
 *
 * Ilgari checkout to'g'ridan-to'g'ri status ekraniga o'tardi va bu
 * tushuntirish HECH QAYERDA aytilmasdi.
 */
export function SuccessScreen({ orderId, number }: { orderId: string; number: string }): ReactNode {
  const { t } = useSettings();
  const { push, switchRoot } = useNavigation();
  const contact = useContact();

  return (
    <div className="aps-screen aps-success">
      <span className="aps-success__mark">
        <IconCheck size={32} label={t('success.title')} />
      </span>

      <h2 className="aps-success__title">{t('success.title')}</h2>
      <p className="aps-success__lead">
        {t('success.number')} <b>{number}</b>
        <br />
        {t('success.callback')}
      </p>

      {/*
        Keyingi qadam — MAJBURIY matn. Mijoz nima kutishini bilmasa,
        u buyurtmani "yakunlanmagan" deb hisoblaydi.
      */}
      <section className="aps-success__next" data-cat="oils">
        <span className="aps-success__next-label">{t('success.nextStep')}</span>
        <p>{t('success.nextBody')}</p>
        <p>{t('success.deliveryNote')}</p>
      </section>

      <ContactCard
        title={t('help.orderTitle')}
        description={t('help.orderBody')}
        hours={contact.hours}
        phone={contact.phone}
        telegram={contact.telegram}
        writeLabel={t('help.write')}
        telegramMessage={`${t('help.orderMessage')} ${number}`}
        onOpenTelegram={openTelegramLink}
      />

      <Button
        variant="primary"
        onClick={() => {
          push({ name: 'order', id: orderId });
        }}
      >
        {t('success.track')}
      </Button>
      <Button
        variant="ghost"
        onClick={() => {
          switchRoot('home');
        }}
      >
        {t('success.continue')}
      </Button>
    </div>
  );
}
